import { render, staticRenderFns } from "./r-card-cluster-page.vue?vue&type=template&id=24c7594d"
import script from "./r-card-cluster-page.vue?vue&type=script&lang=js"
export * from "./r-card-cluster-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c7594d')) {
      api.createRecord('24c7594d', component.options)
    } else {
      api.reload('24c7594d', component.options)
    }
    module.hot.accept("./r-card-cluster-page.vue?vue&type=template&id=24c7594d", function () {
      api.rerender('24c7594d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card-cluster/r-card-cluster-page.vue"
export default component.exports